import {
    Bell, AlertTriangle, TrendingDown, CreditCard,
    BarChart2, AlertCircle, Archive, ExternalLink
} from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const ICONOS = {
    hito_riesgo: { icon: Bell, color: 'text-yellow-500', bg: 'bg-yellow-50' },
    presupuesto_riesgo: { icon: AlertTriangle, color: 'text-orange-500', bg: 'bg-orange-50' },
    liquidez_riesgo: { icon: TrendingDown, color: 'text-red-500', bg: 'bg-red-50' },
    cobro_vencido: { icon: CreditCard, color: 'text-red-500', bg: 'bg-red-50' },
    resumen_semanal: { icon: BarChart2, color: 'text-purple-500', bg: 'bg-purple-50' },
    anomalia_gasto: { icon: AlertCircle, color: 'text-orange-500', bg: 'bg-orange-50' },
}

const formatFecha = (fecha) => {
    const diff = Date.now() - new Date(fecha).getTime()
    const mins = Math.floor(diff / 60000)
    const horas = Math.floor(diff / 3600000)
    const dias = Math.floor(diff / 86400000)
    if (mins < 60) return `Hace ${mins}m`
    if (horas < 24) return `Hace ${horas}h`
    return `Hace ${dias}d`
}

export const NotificacionItem = ({ notificacion, onMarcarLeida, onArchivar }) => {
    const navigate = useNavigate()
    const { icon: Icono, color, bg } = ICONOS[notificacion.tipo] ||
        { icon: Bell, color: 'text-gray-400', bg: 'bg-gray-50' }

    const handleClick = () => {
        if (!notificacion.leida) onMarcarLeida(notificacion.id)
        if (notificacion.accion_url) navigate(notificacion.accion_url)
    }

    return (
        <div
            className={`
        flex items-start gap-3 p-4 rounded-xl border cursor-pointer
        transition-all duration-150 hover:shadow-sm
        ${notificacion.leida
                    ? 'bg-white border-[#EDEDED]'
                    : 'bg-[#FCF1FF] border-[#8E24AA]/20'}
      `}
            onClick={handleClick}
        >
            {/* Ícono */}
            <div className={`flex-shrink-0 w-9 h-9 rounded-full ${bg} flex items-center justify-center`}>
                <Icono className={`w-4 h-4 ${color}`} />
            </div>

            {/* Contenido */}
            <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                    <p className={`text-sm font-medium leading-snug ${notificacion.leida ? 'text-[#595759]' : 'text-[#595759]'}`}>
                        {notificacion.titulo}
                    </p>
                    {!notificacion.leida && (
                        <span className="flex-shrink-0 w-2 h-2 rounded-full bg-[#8E24AA] mt-1.5" />
                    )}
                </div>
                <p className="text-xs text-[#909090] mt-0.5 leading-relaxed">
                    {notificacion.mensaje}
                </p>
                <div className="flex items-center justify-between mt-2">
                    <span className="text-xs text-[#909090]">
                        {formatFecha(notificacion.created_at)}
                    </span>
                    <div className="flex items-center gap-2">
                        {notificacion.accion_url && (
                            <span className="text-xs text-[#8E24AA] flex items-center gap-1">
                                <ExternalLink className="w-3 h-3" />
                                {notificacion.accion_sugerida || 'Ver detalle'}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Archivar */}
            <button
                className="flex-shrink-0 p-1 rounded-lg text-[#909090] hover:text-[#595759] hover:bg-[#F9F9F9] transition-colors"
                onClick={(e) => { e.stopPropagation(); onArchivar(notificacion.id) }}
                title="Archivar"
            >
                <Archive className="w-4 h-4" />
            </button>
        </div>
    )
}